import {
  createContext, useContext, useMemo,
} from 'react';
import { useSetState } from 'react-use';

const appState = {
  run: false,
  stepIndex: 0,
  steps: [],
  tourActive: false,
};

export const TourContext = createContext({
  state: appState,
  setState: () => undefined,
});
TourContext.displayName = 'TourContext';

export function TourProvider(props) {
  const [state, setState] = useSetState(appState);

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [setState, state],
  );

  return <TourContext.Provider value={value} {...props} />;
}

export function useTourContext() {
  const context = useContext(TourContext);

  if (!context) {
    throw new Error('useTourContext must be used within a TourProvider');
  }

  return context;
}
